export function getUfName(ufCode: string) {
	const listUfs: {[ufCode: string]: string} = {
		AC: 'Acre',
		AL: 'Alagoas',
		AP: 'Amapá',
		BA: 'Bahia',
		AM: 'Amazonas',
		CE: 'Ceará',
		ES: 'Espírito Santo',
		GO: 'Goiás',
		MA: 'Maranhão',
		MT: 'Mato Grosso',
		MS: 'Mato Grosso do Sul',
		MG: 'Minas Gerais',
		PA: 'Pará',
		PB: 'Paraíba',
		PR: 'Paraná',
		PE: 'Pernambuco',
		PI: 'Piauí',
		RJ: 'Rio de Janeiro',
		RN: 'Rio Grande do Norte',
		RS: 'Rio Grande do Sul',
		RO: 'Rondônia',
		RR: 'Roraima',
		SC: 'Santa Catarina',
		SP: 'São Paulo',
		SE: 'Sergipe',
		TO: 'Tocantins',
		DF: 'Distrito Federal',
	};
	return listUfs[ufCode.toUpperCase()];
}
